import React from "react";
import tw from "twin.macro";

const Root = tw.div`max-w-screen-xl mx-auto px-4 sm:px-8`;

export const Container: React.FC = ({ children, ...rest }) => {
  return <Root {...rest}>{children}</Root>;
};
